module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/nandu-pentapati-92ee9b362f59627ffaa1f521f57a0421.jpg";